import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetOfferById } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore.ts';
import { queryKeys } from '~/utils/queryKeys';

export const useOfferById = ({ aggregateId, offerId }: { offerId: string; aggregateId: string }) => {
    const queryPosition = useQueryPositionStore(
        (state) => state.positions[JSON.stringify(queryKeys.getOfferById(aggregateId, offerId))],
    );

    return useAggregateQuery({
        acl: { loanRequestId: aggregateId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getOfferById,
        schema: schemaLoanRequestResolver_GetOfferById,
        searchParams: { id: aggregateId, offerId, position: queryPosition },
    });
};
